import React, { useRef, useState, useEffect } from "react";

const url = process.env.REACT_APP_PRODUCTION_FRONTEND;

export const Image = ({ title, Image }) => {
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); 
        }
      },
      { threshold: 0.3 } 
    );

    if (textRef.current) observer.observe(textRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="image-container"
      style={{
        position: "relative",
        display: "inline-block",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <img
        src={url + Image}
        alt={title}
        style={{ display: "block", width: "100%", height: "auto" }}
      />
      <div
        ref={textRef}
        className="slide-in-text"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: isVisible ? "translate(-50%, -50%)" : "translate(-50%, -300%)",
          color: "white",
          fontWeight: "bold",
          fontSize: "15px",
          letterSpacing: "0.05em",
          opacity: isVisible ? 1 : 0,
          transition: "transform 0.8s ease-out, opacity 0.8s ease-out",
        }}
      >
        {title}
      </div>
    </div>
  );
};
